/*
 * diagnosis (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { diagnoses } from "./diagnosis.schema"

/* Select */
export type Diagnosis = z.infer<typeof selectDiagnosisSchema>
export const selectDiagnosisSchema = createSelectSchema(diagnoses)

/* Filters */
export type DiagnosisFilters = z.infer<typeof diagnosisFiltersSchema>
export const diagnosisFiltersSchema = z.object({
	id: z.string().optional(),
	name: z.string().optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createDiagnosisSchema = createInsertSchema(diagnoses, {
	name: z.string().min(1, "Name is required"),
}).partial(globalCreateExclude)
export type CreateDiagnosis = z.infer<typeof createDiagnosisSchema>

/* Update */
export const updateDiagnosisSchema = createInsertSchema(diagnoses)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateDiagnosis = z.infer<typeof updateDiagnosisSchema>
